/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MFAType {
  EMAIL = 'email',
}
